export default __webpack_public_path__ + "static/media/arrow-up.a68eeb28.svg";